import { useSearchParams } from 'react-router-dom';
import { searchKeys } from '../constants/searchKeys';
import { useState } from 'react';
import { useSearchWithSearchParamEffect } from 'hooks/searchParams/useSearchWithSearchParamEffect';

export const useAnalysesPageSearch = () => {
  const [searchParams] = useSearchParams();

  const [searchRole, setSearchRole] = useState(
    searchParams.get(searchKeys.searchRole) ?? ''
  );

  useSearchWithSearchParamEffect({
    searchText: searchRole,
    searchKey: searchKeys.searchRole
  });

  return {
    searchRole,
    setSearchRole
  };
};
